import { render, staticRenderFns } from "./marketingActivityAddAndEdit.vue?vue&type=template&id=6964237b&scoped=true"
import script from "./marketingActivityAddAndEdit.vue?vue&type=script&lang=js"
export * from "./marketingActivityAddAndEdit.vue?vue&type=script&lang=js"
import style0 from "./marketingActivityAddAndEdit.vue?vue&type=style&index=0&id=6964237b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6964237b",
  null
  
)

export default component.exports